import React from 'react'
import './loadingAnimation.css'

// Componente de animação de loading
// Exibe uma animação de loading

function Loading() {
  return (
    <div className="loadingAnimation-box">
        <div className="loadingAnimation-body"></div>
    </div>
  )
}

export default Loading